/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1ExamRevisionLangBotexamlangidMutationRequest,
  PutApiV1ExamRevisionLangBotexamlangidMutationResponse,
  PutApiV1ExamRevisionLangBotexamlangidPathParams,
  PutApiV1ExamRevisionLangBotexamlangid400,
  PutApiV1ExamRevisionLangBotexamlangid401,
  PutApiV1ExamRevisionLangBotexamlangid404,
  PutApiV1ExamRevisionLangBotexamlangid500,
} from "../../types/examRevisionController/PutApiV1ExamRevisionLangBotexamlangid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1ExamRevisionLangBotexamlangid } from "../../clients/examRevisionController/putApiV1ExamRevisionLangBotexamlangid.ts";

export const putApiV1ExamRevisionLangBotexamlangidMutationKey = () =>
  [{ url: "/api/v1/exam/revision/lang/:botExamLangId" }] as const;

export type PutApiV1ExamRevisionLangBotexamlangidMutationKey = ReturnType<
  typeof putApiV1ExamRevisionLangBotexamlangidMutationKey
>;

export function putApiV1ExamRevisionLangBotexamlangidMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1ExamRevisionLangBotexamlangidMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1ExamRevisionLangBotexamlangidMutationKey();
  return mutationOptions<
    PutApiV1ExamRevisionLangBotexamlangidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionLangBotexamlangid400
      | PutApiV1ExamRevisionLangBotexamlangid401
      | PutApiV1ExamRevisionLangBotexamlangid404
      | PutApiV1ExamRevisionLangBotexamlangid500
    >,
    {
      botExamLangId: PutApiV1ExamRevisionLangBotexamlangidPathParams["botExamLangId"];
      data?: PutApiV1ExamRevisionLangBotexamlangidMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ botExamLangId, data }) => {
      return putApiV1ExamRevisionLangBotexamlangid(botExamLangId, data, config);
    },
  });
}

/**
 * @description Atualiza os dados (cultura, título, instrução e situação) de um idioma existente (ClassroomDisciplineBotExamLang). Valida que o código de cultura é permitido pelo sistema e que, caso a cultura seja alterada, não existe outro registro com a mesma combinação BotExamId + CultureInfo. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma de prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId}
 */
export function usePutApiV1ExamRevisionLangBotexamlangid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1ExamRevisionLangBotexamlangidMutationResponse,
      ResponseErrorConfig<
        | PutApiV1ExamRevisionLangBotexamlangid400
        | PutApiV1ExamRevisionLangBotexamlangid401
        | PutApiV1ExamRevisionLangBotexamlangid404
        | PutApiV1ExamRevisionLangBotexamlangid500
      >,
      {
        botExamLangId: PutApiV1ExamRevisionLangBotexamlangidPathParams["botExamLangId"];
        data?: PutApiV1ExamRevisionLangBotexamlangidMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1ExamRevisionLangBotexamlangidMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1ExamRevisionLangBotexamlangidMutationKey();

  const baseOptions = putApiV1ExamRevisionLangBotexamlangidMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1ExamRevisionLangBotexamlangidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionLangBotexamlangid400
      | PutApiV1ExamRevisionLangBotexamlangid401
      | PutApiV1ExamRevisionLangBotexamlangid404
      | PutApiV1ExamRevisionLangBotexamlangid500
    >,
    {
      botExamLangId: PutApiV1ExamRevisionLangBotexamlangidPathParams["botExamLangId"];
      data?: PutApiV1ExamRevisionLangBotexamlangidMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1ExamRevisionLangBotexamlangidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionLangBotexamlangid400
      | PutApiV1ExamRevisionLangBotexamlangid401
      | PutApiV1ExamRevisionLangBotexamlangid404
      | PutApiV1ExamRevisionLangBotexamlangid500
    >,
    {
      botExamLangId: PutApiV1ExamRevisionLangBotexamlangidPathParams["botExamLangId"];
      data?: PutApiV1ExamRevisionLangBotexamlangidMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1ExamRevisionLangBotexamlangidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionLangBotexamlangid400
      | PutApiV1ExamRevisionLangBotexamlangid401
      | PutApiV1ExamRevisionLangBotexamlangid404
      | PutApiV1ExamRevisionLangBotexamlangid500
    >,
    {
      botExamLangId: PutApiV1ExamRevisionLangBotexamlangidPathParams["botExamLangId"];
      data?: PutApiV1ExamRevisionLangBotexamlangidMutationRequest;
    },
    TContext
  >;
}
